import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconRefresh = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.75 12.07c0 .78.148 1.54.444 2.278.295.738.756 1.42 1.383 2.044l.634.635v-1.989c0-.212.072-.39.216-.534a.727.727 0 0 1 .535-.215c.212 0 .39.071.534.215a.727.727 0 0 1 .215.535v3.73c0 .256-.086.47-.26.644a.875.875 0 0 1-.643.26H5.077a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.534a.727.727 0 0 1 .534-.216H7.25l-.727-.696c-.822-.76-1.406-1.612-1.753-2.555a8.209 8.209 0 0 1-.52-2.853c0-1.509.387-2.883 1.162-4.123A7.829 7.829 0 0 1 8.53 5.081a.645.645 0 0 1 .574-.035.64.64 0 0 1 .397.418.822.822 0 0 1-.012.57.824.824 0 0 1-.382.441A6.362 6.362 0 0 0 6.66 8.791a6.159 6.159 0 0 0-.91 3.278Zm12.5-.14c0-.78-.148-1.54-.444-2.278-.295-.738-.757-1.42-1.383-2.044l-.634-.635v1.989c0 .212-.072.39-.216.534a.726.726 0 0 1-.535.216.726.726 0 0 1-.534-.216.727.727 0 0 1-.215-.534V5.23c0-.256.086-.47.26-.644a.875.875 0 0 1 .643-.26h3.731c.213 0 .39.072.535.216a.726.726 0 0 1 .215.534.73.73 0 0 1-.215.535.726.726 0 0 1-.535.215H16.75l.727.696c.79.79 1.366 1.648 1.729 2.575.363.927.544 1.872.544 2.834 0 1.508-.386 2.88-1.157 4.117a7.807 7.807 0 0 1-3.114 2.86.656.656 0 0 1-.574.04.625.625 0 0 1-.397-.413.82.82 0 0 1 .012-.57.83.83 0 0 1 .372-.441 6.363 6.363 0 0 0 2.448-2.316 6.16 6.16 0 0 0 .91-3.278Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconRefresh;
